<template>
  <div v-if="!isLoading && softSkillGlossary.length > 0">
    <div class="glossary vertical position-fixed">
      <b-button
        v-b-toggle.sidebar-glossary
        class="px-5"
        variant="outline-primary"
        @click="openSidebar"
      >
        {{ trans("softskills.sidebar.button") }}
      </b-button>
    </div>
    <b-sidebar
      id="sidebar-glossary"
      shadow="lg"
      bg-variant="white"
      width="340px"
      backdrop
      aria-labelledby="title-sidebar-glossary"
    >
      <template #header="{ hide }">
        <b-button
          squared
          variant="link border-0 ml-auto"
          @click="hide"
          :aria-label="trans('softskills.sidebar.close')"
        >
          <b-icon icon="x" font-scale="2.2" />
        </b-button>
      </template>
      <h5 id="title-sidebar-glossary" class="font-weight-bold border-bottom mx-4 px-3 pb-3 mb-3">
        {{ trans("softskills.sidebar.title") }}
      </h5>
      <div class="mx-4 px-3 py-2 mb-3" v-for="skg in softSkillGlossary" :key="skg.id" tabindex="0">
        <p class="font-weight-bold text-medium d-flex align-items-center mb-2 py-2">
          <b-img :src="skg.icon.url" class="img-fluid" aria-hidden="true" />
          <span class="ml-1 line-height-normal" role="term">{{ skg.glossary.name }}</span>
        </p>
        <p class="font-italic text-medium mb-0" role="definition">{{ skg.glossary.description }}</p>
      </div>
      <div class="vertical glossary inner position-absolute">
        <b-button v-b-toggle.sidebar-glossary class="px-5" variant="outline-primary">{{
          trans("softskills.sidebar.button")
        }}</b-button>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SoftSkillsGlossary",
  props: {
    elementSoftSkills: Array,
  },
  mounted() {
    this.loadSoftSkillGlossaryMiu(this.elementSoftSkills);
  },
  computed: {
    ...mapGetters({
      isLoading: "softSkills/getSoftSkillsLoadingSidebar",
      softSkillGlossary: "softSkills/getSoftSkillGlossaryMiu",
    }),
  },
  methods: {
    ...mapActions({
      loadSoftSkillGlossaryMiu: "softSkills/loadSoftSkillGlossaryMiu",
    }),
    openSidebar() {
      trackEvent("OpenSoftSkillGlossary", {
        streamId: this.$route.params.id,
        aleId: this.$route.params.aleId,
        miuId: this.$route.params.elementId,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.glossary {
  transform-origin: center top;
  transform: translateX(-29%) rotate(90deg);
  top: 50%;
  .btn {
    border-color: $color-dark-600;
    background: white !important;
    &:hover {
      border-color: $color-blue;
      color: $color-blue;
    }
  }
  &.inner {
    left: 335px;
  }
}
</style>
s
